/*
 * NYORD: „Benachrichtige mich“ bei ausverkauften Varianten (Block nb_wieder_da in sections/main-product, statt
 * Vitals Back in Stock). Schickt die E-Mail an Klaviyos Back-in-Stock-Schnittstelle (öffentlicher Schlüssel, nur
 * diese Benachrichtigung, keine Newsletter-Anmeldung); Klaviyo meldet sich per Flow „Back in Stock“, sobald die
 * Variante wieder Bestand hat. Folgt dem Variantenwechsel von Dawn (PUB_SUB_EVENTS.variantChange).
 */
if (!customElements.get('nb-wieder-da')) {
  customElements.define(
    'nb-wieder-da',
    class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.feld = this.querySelector('input[type="email"]');
        this.knopf = this.querySelector('button[type="submit"]');
        this.status = this.querySelector('[data-status]');
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.senden();
        });
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.abmelden = subscribe(PUB_SUB_EVENTS.variantChange, (ereignis) => {
            const v = ereignis.data && ereignis.data.variant;
            // Keine Variante = Kombination gibt es nicht; dann nichts anbieten
            this.hidden = !v || v.available;
            if (!v || String(v.id) === this.dataset.variante) return;
            this.dataset.variante = v.id;
            this.form.hidden = false;
            this.zeigen('', false);
          });
        }
      }

      disconnectedCallback() {
        if (this.abmelden) this.abmelden();
      }

      zeigen(text, fehler) {
        this.status.textContent = text;
        this.status.classList.toggle('nb-wieder-da__status--fehler', Boolean(fehler));
      }

      async senden() {
        const email = this.feld.value.trim();
        if (!email || !this.feld.checkValidity()) {
          this.zeigen(this.dataset.textEmail, true);
          this.feld.focus();
          return;
        }
        this.knopf.disabled = true;
        this.zeigen('', false);
        const kopf = { 'Content-Type': 'application/json', revision: '2025-01-15' };
        try {
          // Sprache am Profil merken: der Klaviyo-Flow schickt danach die deutsche oder englische Mail
          await fetch(`https://a.klaviyo.com/client/profiles/?company_id=${this.dataset.firma}`, {
            method: 'POST',
            headers: kopf,
            body: JSON.stringify({ data: { type: 'profile', attributes: { email, properties: { 'NYORD Sprache': this.dataset.sprache || 'de' } } } }),
          }).catch(() => {});
          const antwort = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.dataset.firma}`, {
            method: 'POST',
            headers: kopf,
            body: JSON.stringify({
              data: {
                type: 'back-in-stock-subscription',
                attributes: {
                  profile: { data: { type: 'profile', attributes: { email } } },
                  channels: ['EMAIL'],
                },
                relationships: {
                  variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${this.dataset.variante}` } },
                },
              },
            }),
          });
          if (!antwort.ok) throw new Error(String(antwort.status));
          this.form.hidden = true;
          this.zeigen(this.dataset.textDanke, false);
        } catch (_) {
          this.zeigen(this.dataset.textFehler, true);
        } finally {
          this.knopf.disabled = false;
        }
      }
    }
  );
}
